import { useAppDispatch } from "../../store/hooks";
import { providers } from "ethers";

export const useMetaMask = () => {
  const dispatch = useAppDispatch();

  return {
    start: async () => {
      //@ts-ignore
      const ethereum = window.ethereum as MetaMaskInpageProvider;
    //   if (ethereum) {
        // From now on, this should always be true:
        // provider === window.ethereum

        //creates an ethers provider from the metamask interface
        let web3Provider = new providers.Web3Provider(ethereum);
        //connects MM to the site
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        //creates a signer with MM
        let signer = web3Provider.getSigner();
        //   //console.log(await signer.getAddress());
        const ethersResp = await web3Provider.getNetwork();
        //   //@ts-ignore
        const account = await signer.getAddress();

        return { address: account, chain: ethersResp.chainId };
    //   }

      
    },
  };
};
